import { useCallback } from 'react';
import { useUrlFilters } from '@/lib/hooks/useUrlFilters';
import type { ExpenseFilters } from '../types';

const defaults: ExpenseFilters = {
  status: undefined,
  expenseCategoryId: undefined,
  matterId: undefined,
  contractId: undefined,
  limit: 20,
  page: 0,
};

const numberFields: (keyof ExpenseFilters)[] = [
  'limit',
  'page',
  'expenseCategoryId',
  'matterId',
  'contractId',
];

// URL-synced expense filters (same shape as useLeoFilters / useClientFilters).
export function useExpenseFilters() {
  const { updateFilter: baseUpdateFilter, ...rest } = useUrlFilters<ExpenseFilters>({
    defaults,
    numberFields,
  });

  // Auto-reset page when any filter other than page or limit changes
  const updateFilter = useCallback(
    <K extends keyof ExpenseFilters>(key: K, value: ExpenseFilters[K]) => {
      baseUpdateFilter(key, value, key !== 'page' && key !== 'limit');
    },
    [baseUpdateFilter],
  );

  return { ...rest, updateFilter };
}
